import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./baseQuery";

// Dummy API (JSONPlaceholder)
export const eventApi = createApi({
  reducerPath: "eventApi ", // optional, defaults to 'api'
  baseQuery: customBaseQuery,
  tagTypes: ["slots"],
  endpoints: (builder) => ({
    getSlotsList: builder.query({
      query: (credentials) => ({
        url: "/event/slots",
        method: "GET",
      }),
      providesTags: ["slots"],
    }),
    bookEvent: builder.mutation({
      query: (data) => ({
        url: "/event/book",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["slots"],
    }),
  }),
});

export const { useGetSlotsListQuery, useBookEventMutation } = eventApi;
